export const WelcomeMessageRoutes = [
  {
    path: 'welcome/:mode?/:content_id?',
    alias: 'welcomeMessage',
    query: ['channel'],
    lazy: () => import('./welcomeMessage.page'),
  },
] as const
